export default {
  addOns: 'Lisäpalvelut',
  all: 'Kaikki',
  browse: 'Selaa',
  buyTickets: 'Osta liput',
  countSelected: '{{count}} valittu',
  joinWaitlist: 'Liity jonotuslistalle',
  joining: 'Liitytään',
  salesEnded: 'Myynti päättynyt',
  schedule: 'Aikataulu',
  soldOut: 'Loppuunmyyty',
  tickets: 'Liput',
  noDatesAvailable: 'Ei saatavilla olevia päivämääriä',
  seeMoreDates: 'Näytä lisää päivämääriä',
  about: 'Tietoja',
  agenda: 'Ohjelma',
  menu: 'Valikko',
  included: 'Sisältyy',
  viewMore: 'Näytä enemmän',
  viewLess: 'Näytä vähemmän',
  location: 'Sijainti',
  time: 'Aika',
  at: 'klo',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Ei saatavilla olevia aikoja tänä päivänä tälle ryhmäkoolle',
  availableTimes: 'Saatavilla olevat ajat',
  waitlist: 'Jonotuslista',
  continue: 'Jatka',
  ticketsAreNoLongerAvailable: 'Lippuja ei ole enää saatavilla.',
  checkOutOutOtherExperiences: 'Tutustu muihin elämyksiimme!',
  viewExperiences: 'Näytä elämykset',
  from: 'alkaen',
  cancellationPolicy: 'Peruutuskäytäntö',
  rsvp: 'RSVP',
  nights: 'yötä',
  request: 'Pyyntö',
  arrival: 'Saapuminen',
  departure: 'Lähtö',
};
